var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWhiteHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 18",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.092 16.52v-.001L2.225 9.373l-.002-.001a5.329 5.329 0 01-1.102-1.746 5.518 5.518 0 01-.37-2.064v-.004a5.04 5.04 0 01.37-1.863 4.86 4.86 0 011.023-1.566c.436-.446.95-.795 1.511-1.031A4.442 4.442 0 015.422.75h.015a4.443 4.443 0 011.797.36c.57.244 1.09.606 1.527 1.066h0l.003.003.667.694.54.562.541-.562.547-.57h0l.007-.006A4.758 4.758 0 0114.138.79a4.69 4.69 0 013.254.965c.532.428.974.971 1.293 1.594a5.189 5.189 0 01.258 4.11 5.009 5.009 0 01-1.09 1.765s0 0 0 0l-7.002 7.294h0a1.246 1.246 0 01-.407.284c-.15.064-.31.097-.47.096H9.97c-.161 0-.321-.032-.471-.096a1.248 1.248 0 01-.407-.284z",
    stroke: "currentColor",
    strokeWidth: "currentColor"
  })));
}

export default SvgWhiteHeart;